import { css } from "styled-components";
import { DEFAULT_BREAKPOINTS } from "../../../../functional/breakpointUtils";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    /* general width & positioning of blades in the page body */
    position: relative;
    max-width: ${DEFAULT_BREAKPOINTS.desktop};
    width: 100%;
    margin: 0 auto;
  }

  background-color: ${paletteTokens.bladebg1};
  color: ${paletteTokens.bladetext1};
`;
//# sourceMappingURL=index.js.map